import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function NewsDetailNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm shadow-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate('/')}
              className="flex items-center gap-2 text-gray-600 hover:text-teal-600 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line text-xl"></i>
              <span className="text-sm font-medium hidden sm:inline">返回首页</span>
            </button>
            <span className="text-gray-300 hidden sm:inline">|</span>
            <img
              src="https://static.readdy.ai/image/335e3e62ea46a4ee8fffcd870552cca1/45145859d95338398b93e9f0fa2b0f33.png"
              alt="龙创未来"
              className="h-8 lg:h-10 w-auto cursor-pointer"
              onClick={() => navigate('/')}
            />
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate('/#news')}
              className="hidden sm:flex items-center gap-1.5 px-4 py-2 text-sm text-gray-600 hover:text-teal-600 transition-colors cursor-pointer"
            >
              <i className="ri-newspaper-line"></i>
              <span>新闻动态</span>
            </button>
            <a
              href="/#contact"
              className="px-5 py-2 bg-gradient-to-r from-teal-500 to-teal-600 text-white text-sm font-medium rounded-full hover:from-teal-600 hover:to-teal-700 transition-all whitespace-nowrap cursor-pointer"
            >
              立即咨询
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
